// Cloudflare Turnstile, the bot check on the anonymous onboarding forms (/apply and the
// invitation page's "Send me a new link"; audit OB-06, ruling 2026-10-20). The site key is
// PUBLIC (it ships in the bundle); its secret pair lives only in the API. Optional: while it is
// blank the widget is off, no Cloudflare script loads and no token is sent.
export const turnstileConfig = {
    siteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY ?? "",
};
